

export default {
  data() {
    return {
      num_per_page: 20,
      num_per_page_options: [5,10,15,20,25,30,50,100],
      page_count: 0,
      page_index: 0,
      page_index_array: [],
      item_interval: ''
    }
  },
  methods: {
    reloadPagination(list) {
      this.list_shown = list;
      this.page_count = Math.ceil(list.length / this.num_per_page);
      this.page_index = 0;
      this.page_index_array = Array.from({length: this.page_count}, (_, i) => i + 1);
      this.updateItemInterval(list);
      // return this.list_shown;
    },
    updateItemInterval(list) {
        const from = this.page_index * this.num_per_page + 1;
        let to = (this.page_index + 1) * this.num_per_page;
        if (to > list.length) to = list.length;
        this.item_interval = `${from} - ${to}`;
        this.list_shown = list.slice(from - 1, to);
    },
    moveToPrevPage(list) {
        if (this.page_index > 0) {
            this.page_index--;
            this.updateItemInterval(list);
            // return this.list_shown;
        }
    },
    moveToPage(page, list) {
        this.page_index = page - 1;
        this.updateItemInterval(list);
        // return this.list_shown;
    },
    moveToNextPage(list) {
        if (this.page_index < this.page_count -1) {
            this.page_index++;
            this.updateItemInterval(list);
            // return this.list_shown;
        }
    },
  }
}
